import { render, staticRenderFns } from "./CardRealEstateMeta.vue?vue&type=template&id=09b50298"
import script from "./CardRealEstateMeta.vue?vue&type=script&lang=js"
export * from "./CardRealEstateMeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports